import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'

const Category = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: ${rem(180)};
  height: ${rem(260)};
  padding: ${rem(16)};
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.four};
  border-radius: ${props => props.theme.borderRadius.S};

  > * + * {
    margin-top: ${rem(8)};
  }
`

function ExperiencesPageCategoryTileLoadingSkeleton() {
  return <Category>
    <div>
      <TextLoadingBox typography="heading6" width="100%" />
      <TextLoadingBox typography="caption-small" width="100%" />
      <TextLoadingBox typography="caption-small" width="100%" />
    </div>
    <LoadingBox style={{ width: rem(100), height: rem(36), borderRadius: 4 }} />
  </Category>
}

export default ExperiencesPageCategoryTileLoadingSkeleton
